export default __webpack_public_path__ + "static/media/light-hive.09c5ffe7.svg";